import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import isoWeek from 'dayjs/plugin/isoWeek'
import 'dayjs/locale/lv'
import 'dayjs/locale/ru'
import 'dayjs/locale/en'

const locale = window.location.pathname.slice(1, 3) ?? 'lv'

dayjs.locale(['lv', 'ru', 'en'].includes(locale) ? locale : 'lv')
dayjs.extend(timezone)
dayjs.extend(utc)
dayjs.extend(customParseFormat)
dayjs.extend(advancedFormat)
dayjs.extend(isoWeek)

export const LATVIA_TIMEZONE = 'Europe/Riga'

class DateTimeUtc {
    private dayjsInstance: dayjs.Dayjs

    constructor(date: dayjs.Dayjs | string, format?: string) {
        this.dayjsInstance = format
            ? dayjs.tz(date, format, 'UTC')
            : dayjs.tz(date, 'UTC')
    }

    toDate(): Date {
        return this.dayjsInstance.toDate()
    }

    get dayjs(): dayjs.Dayjs {
        return this.dayjsInstance
    }

    toLatviaTime(): dayjs.Dayjs {
        return this.dayjsInstance.tz(LATVIA_TIMEZONE)
    }

    isValid(): boolean {
        return this.dayjsInstance.isValid()
    }

    format(formatString: string): string {
        return this.dayjsInstance.format(formatString)
    }

    formatDateAndShortMonthInLatviaTime(): string {
        const localDate = this.toLatviaTime()

        if (localDate.format('MMMM')?.length > 5) {
            return localDate.format(dayjs.locale() === 'en' ? 'Do MMM.' : ('DD. MMM' + (dayjs.locale() === 'lv' ? '.' : '')))

        } else {
            return localDate.format(dayjs.locale() === 'en' ? 'Do MMMM' : 'D. MMMM')
        }
    }
}

export function fromUtc(date: dayjs.Dayjs): DateTimeUtc
export function fromUtc(date: string): DateTimeUtc
export function fromUtc(date: string, format: string): DateTimeUtc | null
export function fromUtc(date: dayjs.Dayjs | string, format?: string): DateTimeUtc | null {
    try {
        if (format) {
            const dateTimeUtcInstance = new DateTimeUtc(date, format)
    
            if (! dateTimeUtcInstance.isValid()) {
                return null
            }
    
            return dateTimeUtcInstance
        }

        return new DateTimeUtc(date)

    } catch {
        return null
    }
}


/**
 * Date objekts vienmēr sevi norādīs pārlūka laika zonā.
 * Lai varētu izmantot DateTimeUtc, izmanto attiecīgo UTC laiku.
 */
export function fromLocalToUtc(date: Date, format?: string): DateTimeUtc {
    return new DateTimeUtc(dayjs(date, format).utc(false)) // eslint-disable-line no-restricted-syntax
}


export function nowUtc(): dayjs.Dayjs {
    // eslint-disable-next-line no-restricted-syntax
    return dayjs().tz('UTC')
}

export function nowInLatvia(): dayjs.Dayjs {
    // eslint-disable-next-line no-restricted-syntax
    return dayjs().tz(LATVIA_TIMEZONE)
}


export { dayjs }

